<div class="modal">
    <header class="header">
        <div class="close-button" (click)="closeModal()">
            <i class="ju ju-close"></i>
        </div>
        <!--        <img class="title-icon"
                     src="./assets/images/icons/icon-heated-gw.svg"/>-->
        <span class="title">Modulkonfiguration</span>
        <div class="refresh"
             fxLayoutAlign="center center"
             (click)="loadModuleConfig()"
             [ngClass]="{ loading: isLoading }">
            <img src="./assets/images/icons/refresh.svg"/>
        </div>
    </header>

    <div class="modal-content">
        <div class="data-content"
             [ngClass]="{ 'no-valid-data': isLoading }">

            <div class="card" *ngFor="let module of moduleConfig?.uvsModule">
                <div class="card-title">Addresse {{ module.address }} - {{ module.typ }}</div>
                <!--<div class="card-content">
                    <div class="sensor-row">
                        <div class="label">Temperatur-Delta</div>
                        <div class="value">{{ module.temperatureThreshold }} °C</div>
                    </div>
                    <div class="sensor-row">
                        <div class="label">Light-Schwelle</div>
                        <div class="value">{{ module.lightThreshold || '-' }}</div>
                    </div>
                    <div class="sensor-row">
                        <div class="label">Leckage-Delta</div>
                        <div class="value">{{ module.lekageThreshold || '-' }}</div>
                    </div>
                    <div class="sensor-row">
                        <div class="label">Strom-Loop-Delta</div>
                        <div class="value">{{ module.currentLoopThreshold || '-' }}</div>
                    </div>
                    <div class="sensor-row">
                        <div class="label">OnChange-Msg</div>
                        <div class="value">{{ module.onChangeMsg ? 'ja' : 'nein' }}</div>
                    </div>
                </div>-->
            </div>
        </div>
    </div>

    <div class="popup-footer">
        <button class="primary" (click)="closeModal()">Schließen</button>
    </div>
</div>
